// #======================================#
// #     _____       _ _       _  _       #
// #    |  __ \     (_) |     | || |      #
// #    | |__) |__ _ _| |___  | || |_     #
// #    |  _  // _` | | / __| |__   _|    #
// #    | | \ \ (_| | | \__ \    | |      #
// #    |_|  \_\__,_|_|_|___/    |_|      #
// #                                      #
// #======================================#

/*global cw_open_register_modal*/
function cw_csrf_protection(xhr) {
  var token = jQuery('meta[name="csrf-token"]').attr('content');
  if (token) {
    xhr.setRequestHeader('X-CSRF-Token', token);
  }
  var old_cookie_raw = $.cookie.raw;
  $.cookie.raw = true;
  var csrf_token = $.cookie('x-s-csrf-token');
  if (csrf_token) {
    xhr.setRequestHeader('X-S-CSRF-Token', csrf_token);
  }
  $.cookie.raw = old_cookie_raw;
}

function setCsrf(csrf) {
  var old_cookie_raw = $.cookie.raw;
  $.cookie.raw = true;
  $.cookie("x-s-csrf-token", csrf, {
    "domain": '.catawiki.'.concat(window.location.hostname.split('.').pop()),
    "path": '/' }
  );
  $.cookie.raw = old_cookie_raw;
}

/****

  function to show a confirm dialog. the callback must be a function which will
  be called (most of the time) when the dialog is completed.
  If a user cancels dialog by clicking outside of the window it will not be
  called.
  callback arguments is an object : { confirmed: boolean }
  Allows custom text in the buttons of the dialog. This is a tweaked backport of
  v3 `cw_show_confirm_dialog` function.

*/

function cw_show_confirm_custom_btns(title,message,callback,btn_true,btn_false) {
  if(!!btn_true && !!btn_false) {
    $('#cw_modal_confirmdialog_true').text(TRANSLATIONS[btn_true] || "Yes");
    $('#cw_modal_confirmdialog_false').text(TRANSLATIONS[btn_false] || "No");
  }
  cw_show_confirm_dialog(title,message,callback);
}

/****

  function to show a confirm dialog. the callback must be a function which will be called (most of the time) when the dialog is completed.
  If a user cancels dialog by clicking outside of the window it will not be called.
  callback arguments is an object : { confirmed: boolean }

*/
var cw_confirmdialog_eventhandler = null;
function cw_show_confirm_dialog(title,message,callback) {

  if(document.apnToolbarUsed || $('body').hasClass("cw_mobile")) {
    // strip html tags.
    message = message.replace(/<[^>]*>/g, " ").replace(/\n/," ").replace(/\s+/g, " ");

    if(confirm(message)) {
      callback({ confirmed: true });

    } else {
      callback({ confirmed: false });
    }
  } else {
    if (!cw_confirmdialog_eventhandler) {
      cw_confirmdialog_eventhandler = { finished: false, callback: callback };
      $("#cw_modal_confirmdialog").on('click',"#cw_modal_confirmdialog_true",function (e) {
        e.preventDefault();
        $("#cw_modal_confirmdialog").modal("hide");
        if (!cw_confirmdialog_eventhandler.finished) {
          cw_confirmdialog_eventhandler.callback({ confirmed: true });
        }
        cw_confirmdialog_eventhandler = { finished: true, callback: null };
      });
      $("#cw_modal_confirmdialog").on('click',"#cw_modal_confirmdialog_false",function (e) {
        e.preventDefault();
        $("#cw_modal_confirmdialog").modal("hide");
        if (!cw_confirmdialog_eventhandler.finished) {
          cw_confirmdialog_eventhandler.callback({ confirmed: false });
        }
        cw_confirmdialog_eventhandler = { finished: true, callback: null };
      });
    }
    else {
      cw_confirmdialog_eventhandler.finished = false;
      cw_confirmdialog_eventhandler.callback = callback;
    }

    var modal = $("#cw_modal_confirmdialog");
    if (modal.hasClass('modal')) { // V2
      $(".modal_header h3",modal).html(title);
      $(".modal_body",modal).html(message);
    } else { // V3
      modal.addClass('modal').removeClass('mfp-hide');
      $(".cw-modal-header h1",modal).html(title);
      $(".cw-modal-body",modal).html(message);
    }

    modal.modal();
  }
}

function ab_or_mobile_swipable_image_gallery() {
  return AB.test('or_mobile_swipable_image_gallery') === 'B';
};

function isMobile() {
  return $(window).width() < 747;
}

function is_on_homepage(){
  return $('body').hasClass("frontpage");
}

function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

var ResendEmailVerification = (function (){
  var self = {
    init: function () {
      this.$wrapper = $('.js-resend-email-wrapper');
      this.$container = $('.js-resend-email-container');
      this.successMessage = I18n.translate('successfully_resent_email_confirmation');
      this.hideClass = 'cw-hide';
      this.disabledClass = 'disabled';
      this.successClass = 'success';
      this.warningClass = 'warning';
      this.userId = $.cookie('user_id');
      this.changeUrl = this.$container.data('edit-url');

      if (this.$wrapper.length && this.userId) {
        this.resendUrl = this.$container.data('resend-url').replace(":user_id", this.userId);

        if (
          typeof AB  === "undefined" ||
          AB === null ||
          $('.cw-nav-steps li.active a').attr('id') !== 'tab_preview_submit' ||
          AB.test('or-skip-seller-email-verification') === 'A'
        ) {
            this.$wrapper.removeClass(this.hideClass);
        }

        this.initializeElements();
        this.assignEvents();
        this.render();
      }
    },

    // Due to aggressive caching we need to generate all user specific data
    initializeElements: function () {
      this.$changeButton = $('<a/>', {
        'class': 'cw-alert-actions__link',
        text: I18n.translate('change_email'),
        href: this.changeUrl
      });

      this.$resendButton = $('<a/>', {
        'class': 'btn btn-orange',
        text: I18n.translate('resend_confirmation_email'),
        href: this.resendUrl
      });

      this.$actionContainer = $('<div/>', {
        'class': 'x-col-6-12 cw-alert-actions'
      });

      this.$secondaryMessage = $('<div/>', {
        'class': 'x-col-6-12',
        text: I18n.translate('please_confirm_the_email', {
          email: cw_store.get('user_email')
        })
      });

      this.$subContent = $('<div/>', {
        'class': 'x-grid'
      });

      this.$header = $('.js-resend-email-header', this.$container);
    },

    assignEvents: function () {
      var _this = this;

      this.$resendButton.on('click', function (event) {
        event.preventDefault();

        var $btn = $(this);
        var targetUrl = $btn.attr('href');

        $btn.prop('disabled', true).addClass(_this.disabledClass);

        $.ajax(targetUrl, {
          method: 'POST',
          success: _this.successHandler.bind(_this),
          error: _this.errorHandler.bind(_this)
        });

        dataLayer.push({
          'event': 'topbar_click',
          'eventCategory': 'userregistration',
          'eventLabel': 'resend_email'
        });
      });

      this.$changeButton.on('click', function (event) {
        event.preventDefault();

        dataLayer.push({
          'event': 'topbar_click',
          'eventCategory': 'userregistration',
          'eventLabel': 'change_email'
        });

        window.location = $(this).attr('href');
      });
    },

    render: function () {
      this.$actionContainer.append([this.$changeButton, this.$resendButton]);
      this.$subContent.append([this.$secondaryMessage, this.$actionContainer]);
      this.$container.append(this.$subContent);

      // make sure dataLayer is already declared
      window.dataLayer = window.dataLayer || [];

      dataLayer.push({
        'event': 'topbar_show',
        'eventCategory': 'userregistration',
        'eventLabel': 'email'
      });
    },

    successHandler: function () {
      this.$header.text(this.successMessage);
      this.$subContent.remove();
      this.$container
        .removeClass(this.warningClass)
        .addClass(this.successClass);
    },

    errorHandler: function () {
      this.$resendButton
        .prop('disabled', false)
        .removeClass(this.disabledClass);
    }
  };

  return {
    init: self.init.bind(self)
  }
})();

function cw_check_if_user_confirmed() {
  var user_id = $.cookie('user_id');

  $.ajaxPrefilter(function(options, originalOptions, xhr) { cw_csrf_protection(xhr); });
  jQuery.support.cors = true;
  jQuery.ajax({
    type: 'GET',
    contentType: "application/json; charset=utf-8",
    url: '/accounts/api/v1/users/' + user_id,
    xhrFields: {withCredentials: true},
    cache: false,
    success: function (data) {

      // if user is not confirmed show notification
      if (!data.user.email.confirmed) {
        ResendEmailVerification.init();
      }
    }
  });
}

function cw_fetch_csrf_token(){
  jQuery.ajax({
    type: 'GET',
    contentType: "application/json; charset=utf-8",
    url: '/accounts/api/v1/users/csrf',
    xhrFields: {withCredentials: true},
    tryCount: 0,
    retryLimit: 1,
    cache: false,
    success: function(data) {
      setCsrf(data.csrf);
    },
    error: function() {
      this.tryCount += 1;
      if (this.tryCount <= this.retryLimit) {
        jQuery.ajax(this);
      }
    }
  });
}

function cw_update_cs_phone(){
  if(cw_store.get_session('cs_phonenumber') && cw_store.get_session('cs_more') && cw_store.get_session('cs_intro') && cw_store.get_session('cs_phone_times') && cw_store.get_session('cs_other_country') && cw_store.get_session('cs_select_country')){
    $('body').addClass('cw-has-phonenumber');
    $('#cw-phonenumber span.number, .cw_main_customer_support span.number').text(cw_store.get_session('cs_phonenumber'));
    $('.cw_phonenumber_times').html(cw_store.get_session('cs_phone_times'));
    $('.cw_phonenumber_header').text(cw_store.get_session('cs_phone_header'));
    $('.cw_phonenumber_intro').html(cw_store.get_session('cs_intro'));
    $('.cw_phonenumber_other').html(cw_store.get_session('cs_other_country'));
    $('.cw_phonenumber_other_select').html(cw_store.get_session('cs_select_country'));
    $('#cs_other').on('change', function(){
      var $option = $(this).children('option').eq(this.selectedIndex).attr('selected', 'selected');
      var $res = $option[0].value.split("|");
      var cs_more = JSON.parse(cw_store.get_session('cs_more'));
      $('.cw_phonenumber_other_details').text($res[1] + " (" + $option[0].text + ")"  +  $cs_more[$res[0]]);
    });
  }
}

function get_cs_phonesupport_select(name, id, optionList, intro, call_free) {
  var combo = $("<select></select>").attr("id", id).attr("name", name);
  combo.append("<option value=\"\">" + intro+ "</option>");
  $.each(optionList, function (i, el) {
    combo.append("<option value=\"" +  el.short_code + "|" + call_free + " " + el.customer_support_phone + "\">" + el.name + "</option>");
  });
  return combo.get(0).outerHTML;
}


function cwBalloonPopups(id, fire){
  if(!id || !fire){return false;}
  if($('.cw-balloon-msg').not('.hide').length > 0 || !cw_store.enabled){return false;}
  var balloon = $('#'+id+'.cw-balloon-msg');
  if(balloon.length == 0){return false;}
  if(fire && cw_store.get(id) != 'true'){
    balloon.removeClass('hide');
    setTimeout(function(){
      balloon.addClass('show').find('.close').on('click', function(){
        balloon.removeClass('show');
        setTimeout(function(){
          balloon.addClass('hide');
        }, 400);
        cw_store.set(id, 'true');
      });
    }, 2000);
  }else{
    balloon.addClass('hide');
  }
}

function replace_auctions_with_custom_list(list, offset) {
  offset = offset || 0;
  replace_list_with_custom_list(list, '#cw_lists_auctions_actual .cw-tiles .cw-list-item', offset);
}

function replace_list_with_custom_list(list, element, offset){
  offset = offset || 0;
  for(var i = offset; i < offset+list.length; i++) {
    $(element)[i].outerHTML = list[i-offset];
  }
}

function cw_show_lists_auctions_themed(){
  $('#cw_lists_auctions_themed').removeClass('hide');
  $('#cw_lists_auctions_themed').blockLinks();
  $('#cw_lists_auctions_themed .cw-list-item .cw-content h2').sameHeight();
  $('#cw_lists_auctions_themed .cw-list-item .cw-content .info').sameHeight();
}

function cw_show_lists_auctions_actual(){
  $('#cw_lists_auctions_actual').removeClass('invisible');
  $('#cw_lists_auctions_actual').blockLinks();
  $('#cw_lists_auctions_actual .cw-tiles').each(function(){
    $(this).find('.cw-list-item .cw-content h2').sameHeight();
    $(this).find('.cw-list-item .cw-content .info').sameHeight();
  });
}

function ga_set_custom_dimension(dimension, value){
  if(value && dimension){
    //ga('set', ('dimension'+dimension), value);
    //ga('send', 'event', 'AB testing', ('dimension'+dimension), value, {nonInteraction:true});
    dataLayer.push({
      'event': 'ab_cd_push',
      'eventCategory': 'AB testing',
      'eventAction': ('dimension'+dimension),
      'eventLabel': value,
      'cdIndex': dimension,
      'cdValue': value
    });
  }
}

(function($) {

  $.fn.extend({

    // make elements stick to top on scroll
    makeSticky: function(sticky_top){
      sticky_top = sticky_top || 0;
      var $els = $(this);
      var stickies = [];
      $els.each(function(i){
        stickies[i] = {};
        stickies[i].$el = $(this);
        if (stickies[i].$el.attr('data-pushup')) {
          stickies[i].$pushup = $(stickies[i].$el.attr('data-pushup'));
        } else {
          stickies[i].$pushup = false;
        }
        stickies[i].pos_left = Math.round(stickies[i].$el.offset().left);
        stickies[i].pos_top = Math.round(stickies[i].$el.offset().top);
        stickies[i].sticky = 'off';
        // touch devices can't do sticky and show keyboard at the same time...
        // so turn off stickyness on focus
        if (Modernizr.touch) {
          var timer;
          stickies[i].$el
            .on('focusin.makeSticky', 'input,textarea,select', function(e) {
              var $_this = $(this);
              $(window).off('scroll.makeSticky');
              stickyOff(stickies[i]);
              stickies[i].$el.css({
                'transform': 'none'
              });
              timer = setTimeout(function(){
                if ($_this.offset().top - $(window).scrollTop() > 72) {
                  $(window).scrollTop($_this.offset().top - 72);
                }
                stickies[i].$el.off('focusin.makeSticky');
              }, 500);
            });
            // .on('focusout.makeSticky', 'input,textarea,select', function(e) {
            //   timer = setTimeout(function(){
            //     $(window).on('scroll.makeSticky', doOnScroll);
            //     $(window).trigger('scroll');
            //   }, 1000);
            // });
        }
      });
      var stickyOn = function(sticky) {
        sticky.$el.addClass('cw-sticky-on');
        sticky.sticky = 'on';
      };
      var stickyOff = function(sticky) {
        sticky.$el.removeClass('cw-sticky-on');
        sticky.sticky = 'off';
        pushupOff(sticky);
      };
      var pushupOn = function(sticky, scrollTop, sticky_top) {
        $('html').addClass('cw-sticky-pushup');
        if (Modernizr.csstransforms3d) {
          sticky.$el.css({
            'transform': 'translate3d(0,' + (sticky.$pushup.offset().top - scrollTop - sticky.$el.outerHeight() - sticky_top) + 'px,0)'
          });
        } else {
          sticky.$el.css({
            'margin-top': (sticky.$pushup.offset().top - scrollTop - sticky.$el.outerHeight() - sticky_top) + 'px'
          });
        }
      };
      var pushupOff = function(sticky) {
        $('html').removeClass('cw-sticky-pushup');
        if (Modernizr.csstransforms3d) {
          sticky.$el.css({
            'transform': 'none'
          });
        } else {
          sticky.$el.css({
            'margin-top': 0
          });
        }
      };
      var doOnScroll = function() {
        var scrollTop = $(window).scrollTop();
        $els.each(function(i){
          if (stickies[i].sticky=='off' && (scrollTop+sticky_top) > stickies[i].pos_top) {
            stickyOn(stickies[i]);
          } else if (stickies[i].sticky=='on' && (scrollTop+sticky_top) <= stickies[i].pos_top) {
            stickyOff(stickies[i]);
          }
          if (stickies[i].sticky=='on' && stickies[i].$pushup.length) {
            if ((scrollTop+sticky_top) > stickies[i].$pushup.offset().top - stickies[i].$el.outerHeight()) {
              pushupOn(stickies[i], scrollTop, sticky_top);
            } else {
              pushupOff(stickies[i]);
            }
          }
        });
      };
      $(window).on('scroll.makeSticky', throttle(doOnScroll, 1000/120));
      $(window).trigger('scroll');
    },

    sameHeight: function(anim){
      var $self = $(this);
      var animation = anim || false; // animation default false
      var heights = [];
      $self.each(function(){
        heights[heights.length] = $(this).outerHeight();
      });
      var maxH = Math.max.apply(Math, heights);
      $self.addClass('same-height').each(function(){
        var pad = parseInt($(this).css('padding-top'),10) + parseInt($(this).css('padding-bottom'),10);
        if (animation) {
          $(this).animate({
            minHeight: maxH - pad + 1
          }, 500);
        } else {
          $(this).css({
            minHeight: maxH - pad + 1
          });
        }
      });
    },

    newWindow: function(features){
      features = features || null;
      $(this).each(function() {
        $(this).on('click.newWindow', function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          window.open(this.href, 'CatawikiPopup', features);
        });
      });
    },

    blockLinks: function() {
      $(this).find('[data-link]').each(function(){
        var $self = $(this);
        var href = $self.find($self.attr('data-link')).attr('href');
        $self
          .hover(function(){
            $self.addClass('hover');
          }, function(){
            $self.removeClass('hover');
          })
          .on('click', function(){
            document.location.href = href;
          })
          .find('.cw-stop_prop').on('click.stop_prop', function(event){
            event.stopPropagation();
          });
      });
    },

    updatesAlert: function(inc) {
      var $el = $(this);
      var counter = parseInt($el.text()) || 0;
      counter += inc;
      if (counter > 0) {
        $el.addClass('cw-updates_alert--has_updates').text(counter);
      } else {
        $el.removeClass('cw-updates_alert--has_updates').text('0');
      }
    },

    stickToTop: function() {
      // not working yet!
      var $els = $(this);
      $els.each(function(){
        var $el = $(this);
        var $clone = $el.clone().addClass('cw-stick_to_top__sticky');
        $el.before($clone);
      });
      var $stickies = $('.cw-stick_to_top__sticky');
      var doOnScroll = function() {
        var scrollTop = $(window).scrollTop();
        $els.each(function(){
          var $el = $(this);
          var $sticky = $el.prev('.cw-stick_to_top__sticky');
          if (scrollTop < $el.offset().top - 67) {
            $el.removeClass('cw-stick_to_top--active');
            $sticky.removeClass('cw-stick_to_top__sticky--active');
            return false;
          } else {
            $els.not($el).removeClass('cw-stick_to_top--active');
            $stickies.not($sticky).removeClass('cw-stick_to_top__sticky--active');
            $el.addClass('cw-stick_to_top--active');
            $sticky.addClass('cw-stick_to_top__sticky--active');
          }
        });
      };
      $(window).on('scroll.stickToTop', throttle(doOnScroll, 1000/60));
      $(window).trigger('scroll');
    }

  });

  $.extend({
    cwQuerystringParameters: {
      get: function() {
        var querystring_parts = window.location.search.replace('?', '').split('&');
        var params = {};
        for (var i=0; i<querystring_parts.length; i++) {
          var key_val = querystring_parts[i].split('=');
          if (key_val.length > 1) {
            params[key_val[0]] = key_val[1];
          }
        }
        return params;
      },
      set: function(params, prefix) {
        if (history && history.pushState) {
          prefix = (prefix && document.location.pathname.indexOf(prefix) != document.location.pathname.length - prefix.length) ? prefix : ''; // if prefix is not yet in pathname
          var querystring = [];
          $.each(params, function(param_key, param_val){
            if (param_val) {
              querystring.push(param_key + "=" + param_val);
            }
          });
          querystring = querystring.join('&');
          history.pushState(null, null, document.location.pathname+prefix+'?'+querystring);
        }
      }
    }
  });

  var smoothAnchors = function(offset, beforeScroll, afterScroll) {
    var my_offset = offset || 0;
    var my_beforeScroll = beforeScroll || function() {};
    var my_afterScroll = afterScroll || function() {};
    var speed = 400;
    var scrollIt = function(hash, $target) {
      $target = $target || $(document.getElementById(hash.slice(1)));
      $target = $target.length && $target || $('[id="' + hash.slice(1) +'"]');
      $target = $target.length && $target || $('a[name="' + hash.slice(1) +'"]');
      if ($target.length) {
        var targetOffset = $target.offset().top;
        my_beforeScroll();
        $('html,body').animate({scrollTop: targetOffset - my_offset}, speed, function(){
          if (history && history.pushState) {
            history.pushState(null, null, hash);
          }
          $target.focus();
          my_afterScroll();
        });
      }
    };
    $('a[href*=\\#]').not('.cw-tabs-tab_link, .cw-toggle_link').not('[class*="js-"]').on('click.smoothAnchors', function(event) {
      if (this.hash) {
        try {
          var $target = $(this.hash);
        } catch(e) {
          var $target = null;
        }
        if ($target) {
          $target = $target.length && $target || $('a[name="' + this.hash.slice(1) +'"]');
          $target = $target.length && $target || $('[id="' + this.hash.slice(1) +'"]');
          if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname && $target.length > 0) {
            event.preventDefault();
            scrollIt(this.hash, $target);
          }
        }
      }
    });
    var current_hash = document.location.hash;
    if (current_hash) {
      $('body').imagesLoaded(function(){
        setTimeout(function(){
          scrollIt(current_hash);
        }, 100);
      });
    }
  };



  var cwToggleLinks = function() {
    // use .cw-toggle_link to show/hide $(:data-target)
    // use .open on .cw-toggle_link to set default state "open"
    var toggleText = function($toggle_link) {
      var newtext = $toggle_link.attr('data-hidetext');
      if (newtext) {
        var hidetext = $toggle_link.text();
        $toggle_link.text(newtext);
        $toggle_link.attr('data-hidetext', hidetext);
      }
    };
    var toggleIt = function($toggle_link, $target) {
      if ($toggle_link.hasClass('open')) {
        $toggle_link.removeClass('open');
        $target.addClass('hide').removeClass('cw-toggle_link-open').addClass('cw-toggle_link-closed');
        HashBang.set('toggle', '');
      } else {
        $toggle_link.addClass('open');
        $target.removeClass('hide cw-toggle_link-closed').addClass('cw-toggle_link-open');
        HashBang.set('toggle', $toggle_link.attr('data-target').replace('#', ''));
      }
      toggleText($toggle_link);
    }
    var getTarget = function($toggle_link) {
      return $($toggle_link.attr('data-target'));
    }
    var $toggle_links = $('.cw-toggle_link');
    $toggle_links.each(function(){
      var $toggle_link = $(this);
      var $target = getTarget($toggle_link).addClass('cw-toggle_link-target');
      if (!$toggle_link.hasClass('open')) {
        $target.addClass('hide').removeClass('cw-toggle_link-open').addClass('cw-toggle_link-closed');
      } else {
        toggleText($toggle_link);
      }
      $toggle_link.on('click.cw_toggle', function(event){
        event.preventDefault();
        toggleIt($toggle_link, $target);
      });
    });
    var toggle_from_hash = HashBang.get('toggle');
    if (toggle_from_hash) {
      var $current_toggle = $toggle_links.filter('[data-target="#'+toggle_from_hash+'"]').eq(0);
      toggleIt($current_toggle, getTarget($current_toggle));
    }
  };



  var cwCollapsibles = function() {
    var trigger_selector = 'h1, h2';
    $('.cw-collapsible').each(function(){
      var $item = $(this);
      $item.find(trigger_selector).eq(0)
        .addClass('cw-collapsible-trigger')
        .on('click.cwCollapsibles', function(event){
          event.preventDefault();
          $item.toggleClass('cw-collapsed');
        })
    });
  };



  var toggleGrid = function() {
    $(window).keypress(function(event) {
      if (event.which == 169) { // alt-cmd-G
        $('body').toggleClass('grid');
      }
    });
  };



  var Mason = function(container, items) {
    this.container = container;
    this.$container = $(container);
    this.items = items;
    this.filters = {};
    if (this.$container.attr('data-infinite-scroll') == 'true') {
      this.infinite_scroll = true;
    } else {
      this.infinite_scroll = false;
    }
  };

  Mason.prototype.init = function() {
    var self = this;
    var layout = self.$container.attr('data-layout-mode') || 'masonry';
    //self.$container.imagesLoaded(function(){
      self.$container.isotope({
        layoutMode: layout,
        itemSelector: self.items
      });
      $('a[data-filter-target="'+self.container+'"]').each(function(){
        var $this = $(this);
        if ($this.attr('data-filter') == '*') {
          $this.addClass('active');
        }
        var item_count = self.$container.find(self.items).filter($this.attr('data-filter')).length;
        $this.on('click', function(event){
          event.preventDefault();
          self.$container.parent().find('p.cw-no-results').remove();
          var $buttonGroup = $this.closest('.cw-button-group');
          $buttonGroup.find('.active').removeClass('active');
          $(this).addClass('active');
          var noResultsText = $buttonGroup.attr('data-no-results-text');
          if (item_count < 1 && noResultsText) {
            noResultsText = noResultsText.replace('%{category_name}', $(this).text().toLowerCase());
            self.$container.before(
              $('<p/>').addClass('cw-no-results cw-centered').text(noResultsText)
            );
          }
          var filterGroup = $buttonGroup.attr('data-filter-group');
          self.filters[filterGroup] = $this.attr('data-filter');
          self.applyFilters();
          if (history && history.pushState) {
            history.pushState(null, null, this.href);
          }
        });
      });
      $('select[data-filter-target="'+self.container+'"]').each(function(){
        var $buttonGroup = $(this).closest('.cw-button-group');
        var filterGroup = $buttonGroup.attr('data-filter-group');
        $(this).on('change', function(){
          var $this = $(this);
          var $option = $this.children('option').eq(this.selectedIndex).attr('selected', 'selected');
          var item_count = self.$container.find(self.items).filter($option.attr('data-filter')).length;
          $('.cw-msnry-count').text(item_count);
          cwPluralize($('.cw-msnry-count-pluralize'), item_count);
          self.$container.parent().find('p.cw-no-results').remove();
          var noResultsText = $buttonGroup.attr('data-no-results-text');
          if (item_count < 1 && noResultsText) {
            noResultsText = noResultsText.replace('%{category_name}', $(this).text().toLowerCase());
            self.$container.before(
              $('<p/>').addClass('cw-no-results cw-centered').text(noResultsText)
            );
          }
          self.filters[filterGroup] = $option.attr('data-filter');
          HashBang.set('filter-'+filterGroup, $this.val());
          self.applyFilters();
        });
        var current_filter = HashBang.get('filter-'+filterGroup);
        if (current_filter) {
          for (var i=0; i<$(this).get(0).options.length; i++) {
            if ($(this).get(0).options[i].value == current_filter) {
              $(this).get(0).selectedIndex = i;
              $(this).trigger('change');
              break;
            }
          }
        }
      });
      if (self.infinite_scroll) {
        self.infiniteScroller();
      }
    //});
  };

  Mason.prototype.applyFilters = function() {
    var filterValue = '';
    for (var prop in this.filters) {
      filterValue += this.filters[prop];
    }
    if (filterValue == '*' || filterValue == '') {
      this.$container.removeClass('cw-msnry-filtered');
    } else {
      this.$container.addClass('cw-msnry-filtered');
    }
    this.$container.isotope({ filter: filterValue });
    window.setTimeout(function(){
      $(window).trigger('scroll'); // trigger lazy images
    }, 750);
  };

  Mason.prototype.infiniteScroller = function() {
    $('section.cw-footer').hide();
    var self = this;
    var last = $('.cw-pager').find('a').not('.cw-pager-next').not('.cw-pager-hidden-next').last().text();
    $('.cw-pager').css('visibility', 'hidden');
    var $binder = $(window);
    var img_data = "data:image/gif;base64,R0lGODlhEAALAPQAAP///wAAANra2tDQ0Orq6gYGBgAAAC4uLoKCgmBgYLq6uiIiIkpKSoqKimRkZL6+viYmJgQEBE5OTubm5tjY2PT09Dg4ONzc3PLy8ra2tqCgoMrKyu7u7gAAAAAAAAAAACH+GkNyZWF0ZWQgd2l0aCBhamF4bG9hZC5pbmZvACH5BAALAAAAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAEAALAAAFLSAgjmRpnqSgCuLKAq5AEIM4zD";
    img_data += "Vw03ve27ifDgfkEYe04kDIDC5zrtYKRa2WQgAh+QQACwABACwAAAAAEAALAAAFJGBhGAVgnqhpHIeRvsDawqns0qeN5+y967tYLyicBYE7EYkYAgAh+QQACwACACwAAAAAEAALAAAFNiAgjothLOOIJAkiGgxjpGKiKMkbz7SN6zIawJcDwIK9W/HISxGBzdHTuBNOmcJVCyoUlk7CEAAh+QQACwADACwAAAAAEAALAAAFNSAgjqQIRRFUAo3jNGIkSdHqPI8Tz3V55zuaDacDyIQ+YrBH+";
    img_data += "hWPzJFzOQQaeavWi7oqnVIhACH5BAALAAQALAAAAAAQAAsAAAUyICCOZGme1rJY5kRRk7hI0mJSVUXJtF3iOl7tltsBZsNfUegjAY3I5sgFY55KqdX1GgIAIfkEAAsABQAsAAAAABAACwAABTcgII5kaZ4kcV2EqLJipmnZhWGXaOOitm2aXQ4g7P2Ct2ER4AMul00kj5g0Al8tADY2y6C+4FIIACH5BAALAAYALAAAAAAQAAsAAAUvICCOZGme5ERRk6iy7qpyHCVStA3gNa/7txxwlwv2";
    img_data += "isSacYUc+l4tADQGQ1mvpBAAIfkEAAsABwAsAAAAABAACwAABS8gII5kaZ7kRFGTqLLuqnIcJVK0DeA1r/u3HHCXC/aKxJpxhRz6Xi0ANAZDWa+kEAA7AAAAAAAAAAAA";
    self.$container.infinitescroll(
      {
        binder: $binder,
        navSelector  : '.cw-pager',
        nextSelector : '.cw-pager a.cw-pager-next',
        itemSelector : '.cw-msnry ' + self.items,
        loading: {
          finishedMsg: "",
          img: img_data,
          msgText: "",
          speed: 0
        },
        bufferPx: $(window).height() * 2,
        maxPage: last,
        debug: false
      },
      function(newElements, opts) {
        var $newElems = jQuery(newElements).hide();
        $newElems.imagesLoaded(function(){
          $newElems.fadeIn();
          self.$container.isotope('appended', $newElems);
          self.$container.blockLinks();
          if (opts.state.currPage >= last) {
            $('section.cw-footer').show();
          }
          if (window.AuctionFavorites !== undefined && window.AuctionPage !== undefined) {
            AuctionFavorites.activate_favorites_async(AuctionPage);
          }
        });
      }
    );
  };

  var pageFillHeight = function() {
    $('body').imagesLoaded(function(){
      var window_height = $(window).height();
      if ($('body').outerHeight() < window_height) {
        $('#cw-main').css('min-height', window_height - $('.cw-footer').height() - parseInt($('body').css('padding-top'),10));
      }
    });
  };

  var cwTabs = function() {
    var hideAll = function($tab_links) {
      $tab_links.each(function(){
        $(this).parent('li').removeClass('active');
        var h = $(this).attr('href');
        $(h).hide();
      });
    };
    $('.cw-tabs-active').each(function(){
      var $tabs = $(this);
      var $tab_links = $tabs.find('a');
      // make tab_links open their tab and close all others
      $tab_links.each(function(){
        var $_this = $(this);
        var h = $_this.attr('href');
        $(h).addClass('tab-pane').removeClass('hide');
        var $other_links = $('a[href="'+h+'"]').not($_this);
        $other_links.addClass('cw-tabs-tab_link').off('click.smoothAnchors').on('click.cwTabs', function(event){
          event.preventDefault();
          $_this.trigger('click');
          var targetOffset = $_this.offset().top;
          $('html,body').animate({scrollTop: targetOffset - 75}, 500, function(){
            $(h).focus();
          });
        });
        $_this.addClass('cw-tabs-tab_link').off('click.smoothAnchors').on('click.cwTabs', function(event){
          event.preventDefault();
          hideAll($tab_links);
          $(this).parent('li').addClass('active');
          $(h).show();
          if (set_hash) {
            HashBang.set('tab', h.replace('#', ''));
          }
          set_hash = ($tabs.data('set_hash') == true);
          $(window).trigger('scroll');
        });
      });
      var tab_id = '';
      // check if there's a valid tab selected in url hash
      var current_tab = '#' + HashBang.get('tab');
      var $current_tab = $tab_links.filter('[href="'+current_tab+'"]');
      var real_hash = document.location.hash;
      var $real_hash = $(document.getElementById(real_hash.slice(1)));
      // maybe the url hash is a tab-pane?
      if ($real_hash.length && $current_tab.length < 1) {
        if ($real_hash.hasClass('.tab-pane')) {
          $current_tab = $tab_links.filter('[href="'+real_hash+'"]');
        }
      }
      // maybe there's a hash within a tab-pane selected?
      if ($real_hash.length && $current_tab.length < 1) {
        tab_id = $real_hash.closest('.tab-pane').attr('id');
        $current_tab = $tab_links.filter('[href="#'+tab_id+'"]');
      }
      // if still no valid tab selected, select the default tab (.active)
      if ($current_tab.length < 1) {
        $current_tab = $tabs.find('li.active a');
      }
      var set_hash = false;
      // click the selected tab (if so), else click the first tab
      if ($current_tab.length) {
        $current_tab.trigger('click');
      } else {
        $tab_links.eq(0).trigger('click');
      }
    });
  };



  // conditional comment for <IE9, but more browsers don't support svg... :(
  var changeSVGtoPNG = function() {
    if ($('html').hasClass('mod-no-inlinesvg')) {
      $('img').each(function(){
        var src = $(this).attr('src');
        if (src.indexOf('.svg') > -1) {
          $(this).attr('src', src.replace('.svg', '.png'));
        }
      });
    }
  };



  function loadSocialMediaAsync() {
    //facebook
    var current_locale = $("body").data("locale");
    if(current_locale != "zh_CN") {
      if (!$('html').hasClass("lt-ie8")) {
        var fb_locale = "nl";
        if (current_locale) {
          fb_locale = current_locale.replace("-", "_").replace("du", "de").replace("DU", "DE");
        }
        setTimeout(
            function () {
              (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                  return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = "//connect.facebook.net/" + fb_locale + "/all.js#xfbml=1&appId=610120832449695";

                fjs.parentNode.insertBefore(js, fjs);
              }(document, 'script', 'facebook-jssdk'));
            }, 300);
      }
      //twitter
      setTimeout(
          function () {
            var dummy = !function (d, s, id) {
              var js, fjs = d.getElementsByTagName(s)[0];
              if (!d.getElementById(id)) {
                js = d.createElement(s);
                js.id = id;
                js.src = "//platform.twitter.com/widgets.js";
                fjs.parentNode.insertBefore(js, fjs);
              }
            }(document, "script", "twitter-wjs");
          }, 300);
    }
    //pinterest
    setTimeout(function (){
      var script = document.createElement("script");
      script.async = true;
      script.src = "//assets.pinterest.com/js/pinit.js";
      var heads = document.getElementsByTagName('head');
      if(heads.length>0) {
        heads[0].appendChild(script);
      }
    }, 300);
  }



  //set login class on body
  var setLoginClass = function() {
    var user_name = $.cookie('user_name');
    if (!user_name || typeof user_name !="string") {
      $('body').removeClass('cw_logged_in').addClass('cw_not_logged_in');
      user_name = null;
      cw_update_cs_phone();
      if (cw_store.enabled && cw_store.get('auto_show_login_menu') != 'true' && $('#login_form').length < 1) {
        setTimeout(function(){
          cw_store.set('auto_show_login_menu', 'true');
          var $login_menu = $('#cw_user_navigation .cw_not_logged_in .cw_dropmenu');
          $login_menu.addClass('force-open');
          $login_menu.addClass('open');
          setTimeout(function(){
            $login_menu.removeClass('force-open');
            $login_menu.removeClass('open');
          }, 15000);
        }, 1500);
      }
      $('.cw-featured_nav__items').removeClass('cw-hide');
    } else {
      $('body').removeClass('cw_not_logged_in').addClass('cw_logged_in');
      var $headerUsername = $('.js-header-username');
      var $headerSettingsUsername = $('.js-header-settings-username');

      var hasNoUsername = /^user-/.test(user_name);
      var defaultUsername = $headerUsername.data('default');

      $headerUsername.text(hasNoUsername ? defaultUsername : user_name);

      if (!hasNoUsername) {
        $headerSettingsUsername.removeClass('cw-hide').text(user_name);
      }

      // https://jira.catawiki.net/browse/OR-352
      var isDesktop = $(window).width() > 996;
      if (isDesktop && hasNoUsername) {
        $profileDropdown = $('.js-ab-profile-dropdown');
        $profileDropdown.toggleClass('cw-hide').parent().addClass('cw-dropdown__has-avatar');
      }

      if (typeof AB !== 'undefined' && AB.test('profile_page') === 'B') {
        $('.js-ab-profile-page').removeClass('cw-hide');
      }

      if(!!window.user_id){
        window.AB_USER_ID = window.user_id;
      }
    }
  }

  // activate popups & modals
  var activatePopups = function($container) {
    $container = $container || $('html');

    $container.find("a.register_link").click(function(event) {
      if(!$("html").hasClass("lt-ie8")) {
        $(this).blur();
        event.preventDefault();
        $('html').addClass('mfp-open');
        var url = $(this).attr('data-magnific-popup-link');
        cw_open_register_modal($, url, true);
      }
    });

    var makePopup = function($el,options) {
      options = options || {} ;
      var scrollTo = $el.data('cw-ajax-modal-scroll-to');
      var is_wide = $el.data('cw-ajax-modal-wide') || false;
      var is_medium = $el.data('cw-ajax-modal-medium') || false;
      var typeStr = options.inline ? 'inline' : 'ajax';
      var load_only = $el.data('cw-ajax-modal-load-only');
      var load_only_child = $el.data('cw-ajax-modal-load-only-child');
      var support_cors = $el.data('support_cors') || false;
      var dialog = {
        type: typeStr,
        mainClass: (is_wide) ? 'cw-popup-wide' : ((is_medium) ? 'cw-popup-medium' : 'cw-popup-normal'),
        callbacks: {
          parseAjax: function(mfpResponse) {
            mfpResponse.data = $(mfpResponse.data);
            if (load_only) {
              var $content = $('<div class="cw_white_modal_block" />');
              var $title = $(mfpResponse.data).find(load_only);
              var $text;
              $title.each(function(){
                $text = $(this).next();
                if(load_only_child){
                  var $child = $text.find(load_only_child);
                  if($child.length){
                    $text = $('<p />').text($child.text());
                  }
                }
                $content.append(this).append($text);
              });
              mfpResponse.data = $content;
            }
            $(mfpResponse.data).find('#managed_content table').attr('border', '0').addClass('table-striped');
            $(mfpResponse.data).find('a.replace_popup').each(function(i) {
              $(this).each(function() {
                makePopup($(this));
              });
            });
            createPopupLinks($(mfpResponse.data));
            $(mfpResponse.data).find('a.cw-popup_link').newWindow('width=750,height=525,status=1,location=1');
          },
          ajaxContentAdded: function() {
            moveCloseButton();
            cw_check_disable_loading_buttons($);
            $('input, textarea').placeholder();
            if (scrollTo) {
              var el = document.getElementById(scrollTo);
              if (el) {
                el.scrollIntoView();
              }
            }
          }
        }
      };
      if (support_cors) {
        dialog.ajax = {
          settings: {
            beforeSend: function(request) {
              request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            },
            xhrFields: {
              withCredentials: true
            }
          }
        }
      }
      if (options.inline) {
        if ($el.data('cw-inline-modal-target')) {
          var $content = $($el.data('cw-inline-modal-target')).hide();
        } else {
          var $content = $('<div class="cw_white_modal_block" />');
          if (options.title) {
            $content.append($('<h1>' + options.title + '</h1>'));
          }
          if (options.body) {
            $content.append($('<p>' + options.body + '</p>'));
          }
        }
        createPopupLinks($content);
        dialog.items = {
          type: 'inline',
          src: $content
        }
        dialog.callbacks.open = function() {
          $('html').addClass('mfp-open');
          $content.show();
          $(window).trigger('scroll');
        }
        dialog.callbacks.close = function() {
          $('html').removeClass('mfp-open');
          $content.hide();
          HashBang.set('auctioneer', '');
        }
      }
      return $el.magnificPopup(dialog);
    };
    var moveCloseButton = function(){ // button needs to be moved out of the content!
      $('.mfp-container button.mfp-close').each(function(){
        $(this).appendTo($(this).closest('.mfp-container'));
        $container.find('.cw-has_tooltip').cwTooltip();
      });
    };
    var createPopupLinks = function($el){
      $el.find('a.cw-ajax_popup').magnificPopup({ // load original link in popup through ajax
        type: 'ajax',
        width: 640,
        gallery: {
          enabled: true,
          tPrev: TRANSLATIONS.gallery_previous_left_key,
          tNext: TRANSLATIONS.gallery_next_right_key,
          tCounter: '<span class="mfp-counter">'+TRANSLATIONS.gallery_x_of_total+'</span>'
        },
        callbacks: {
          ajaxContentAdded: function() {
            moveCloseButton();
          }
        }
      });
      $el.find("*[data-cw-inline-modal=true]").each(function() {
        makePopup($(this), {
          inline: true,
          title: $(this).data('cw-title'),
          body: $(this).data('cw-text')
        });
      });
      $el.find("*[data-cw-ajax-modal=true]").each(function() {
        makePopup($(this));
      });
    };
    createPopupLinks($container);
    $.magnificPopup.defaults.callbacks = {
      open: function() {
        $('html').addClass('mfp-open');
      },
      close: function() {
        $('html').removeClass('mfp-open');
      },
      change: function() {
        setTimeout(function(){
          moveCloseButton();
          $('body > .cw-tooltip').remove();
        }, 0);
      },
      ajaxContentAdded: function() {
      }
    };
    $.fn.extend({
      modal: function(param) {
        if (param == 'hide') {
          $.magnificPopup.close();
        } else {
          $(this).find('.cw-modal-close').on('click', function(){
            $.magnificPopup.close();
          });
          $.magnificPopup.open({
            modal: true,
            type: 'inline',
            items: {
              src: $(this)
            }
          });
        }
      }
    });
    if (TRANSLATIONS) {
      $.magnificPopup.defaults.tLoading = TRANSLATIONS.loading + "…";
    }
  };
  $.fn.extend({
    activatePopups: function() { activatePopups($(this)); }
  });


  var initGalleries = function($container) {
    $container = $container || $(document);
    $container.find("*[data-cw-gallery=true]").each(function() {
      var delegate = $(this).data("cw-delegate");
      if(!delegate) {
        delegate = "a";
      }
      $(this).magnificPopup({
        delegate: delegate,
        type: 'image',
        gallery: {
          enabled: true,
          tPrev: TRANSLATIONS.gallery_previous_left_key,
          tNext: TRANSLATIONS.gallery_next_right_key,
          tCounter: '<span class="mfp-counter">'+TRANSLATIONS.gallery_x_of_total+'</span>'
        }
      });
    });
  };

  var showLoginModal = function () {
    if((new RegExp("[\\?&]show_login_modal=true")).test(location.href)) {
      var qs = "";
      var lot_id = $('.row.cw_lot_content .lot.detail #lot_id').val();
      var auction_id = $('.cw_auction_content input#auction_id').val();

      if(typeof lot_id != 'undefined') {
        qs = "?lot_id="+encodeURIComponent(lot_id);
      } else if(typeof auction_id != 'undefined') {
        qs = "?auction_id="+encodeURIComponent(auction_id);
      }
      $.magnificPopup.open({
        items: {
          src: '/register_user/show_login_modal' + qs
        },
        type: 'ajax',
        callbacks: {
          ajaxContentAdded: function() {
            $('.mfp-ajax-holder button.mfp-close').each(function(){
              $(this).appendTo($(this).closest('.mfp-ajax-holder'));
            });
          }
        }
      }, 0);
    }
  };



  // Inline Hints (implement as cw-assets plugin later!)
  window.inlineHints = {
    hints: {},
    hideEvent: 'mousedown.inline_hints, touchstart.inline_hints',
    lastFocus: null,
    init: function(){
      var _this = this;
      this.attachHints($('a.js-inline-hint-trigger'));
      this.hints = $('.c-inline-hint');
      this.hints.each(function(){
        var $hint = $(this);
        $hint.find('.c-inline-hint__inner').on(window.inlineHints.hideEvent, function(evt){
          evt.stopPropagation();
        });
        $hint.find('.c-inline-hint__close, .js-inline-hint-dismiss').on('click', function(evt){
          window.inlineHints.closeHint($hint);
        });

        if ($hint.is('[data-auto-open]')) {
          _this.openHint($hint);
        }
      });
    },
    attachHints: function($triggers) {
      $triggers.on('click.inline_hints', function(evt){
        evt.preventDefault();
        window.inlineHints.openHint($($(this).attr('href')));
      });
    },
    openHint: function($hint) {
      if ($hint.hasClass('open')) {
        this.closeHint($hint);
      } else {
        this.closeAllHints();
        this.lastFocus = document.activeElement;
        $hint.addClass('open').removeAttr('hidden').attr('tabindex', '0').trigger('focus');
        if (!$hint.data('force-open')) { // prevent close on clicking somewhere else
          $('body').on(this.hideEvent, function(){
            window.inlineHints.closeAllHints();
          });
        }
        $(document).on('keydown.inline_hints', function(evt) {
          if (evt.keyCode == 27 ) { // Escape key
            evt.preventDefault();
            window.inlineHints.closeAllHints();
          }
        });

        // Restrict background scrolling on mobile devices
        if (!$hint.hasClass('force-inline')) {
          if (typeof window.matchMedia === "function" && window.matchMedia("(max-width: 746px)").matches) {
            $('body').css('overflow', 'hidden');
          }
        }
      }
    },
    closeHint: function($hint) {
      $hint.addClass('closing').removeAttr('tabindex');
      $('body').off(this.hideEvent);
      $(document).off('keydown.inline_hints');
      $(this.lastFocus).trigger('focus');
      setTimeout(function(){
        $hint.removeClass('closing open').attr('hidden', 'true');

        // Restore body scrolling if this was the last open hint
        if ($('.c-inline-hint.open').length === 0) {
          $('body').css('overflow', 'auto');
        }
      }, 500);
      $(document).trigger('inline_hint_closed:'+$hint.data('hint-id'));
    },
    closeAllHints: function() {
      var $open_hints = this.hints.filter('.open:not([data-force-open])');
      if ($open_hints.length > 0) {
        this.closeHint($open_hints);
      }
    }
  };



  // App signup
  var appSignup = function() {
    if ($.cookie("app_signup_success")) {
      $('#cw_app_signup_linkbanner, #cw_app_signup_banner, .app_signup_linkbanner_small, .app_signup_link').remove();
    }
  };



  var cwNiceSelects = function() {
    $('div.cw-custom_select').remove();
    $('select.cw-nice_select').each(function(){
      var $_this = $(this);
      var state = false;
      var $custom_select = $('<div/>')
        .addClass('cw-custom_select')
        .text(cwGetSelectedOptionText($_this))
        .append(
          $('<span/>').addClass('cw-custom_select-button')
        );
      $_this
        .css({
          'position': 'absolute',
          'z-index': 1,
          'opacity': 0
        })
        .after($custom_select)
        .on('focus.cwNiceSelects', function(){
          if (!state) {
            state = true;
            $custom_select.addClass('active');
          }
        })
        .on('blur.cwNiceSelects', function(){
          if (state) {
            state = false;
            $custom_select.removeClass('active');
          }
        })
        .on('change.cwNiceSelects', function(){
          $custom_select.text(cwGetSelectedOptionText($_this)).append(
            $('<span/>').addClass('cw-custom_select-button')
          );
        });
    });
  };
  $.extend({
    cwNiceSelects: cwNiceSelects
  });

  var initLotGallerySwiper = function() {
    var delay = 7000;
    var $lotCarousel = $('.cw-lot-carousel');
    var timeout;

    // init swipe lot carousel
    $lotCarousel.slick({
      variableWidth: true,
      mobileFirst: true,
      arrows: false,
      lazyLoad: 'progressive',
      autoplay: true,
      autoplaySpeed: delay,
      infinite: false,
      waitForAnimate: false,
      swipeToSlide: true,
      fullscreenEl: true
    });

    // animate back to first slide when reaching last
    $lotCarousel.on('afterChange', function(event, slick, currentSlide) {
      var lastIndex = slick.slideCount - 1;

      clearTimeout(timeout);
      // I have no way to know if autoplay is off or on
      // so I'll start autoplaying anyways
      $lotCarousel.slick('slickPlay');

      if (lastIndex === currentSlide) {
        $lotCarousel.slick('slickPause');

        timeout = setTimeout(function() {
          $lotCarousel
            .slick('slickGoTo', 0, false)
            .slick('slickPlay');
        }, delay);
      }
    });
  };

  // init photoswipe gallery for mobile
  var initLotGalleryMobile = function(gallerySelector) {
    var parseThumbnailElements = function($el) {
      var $slides = $el.children();
      var photoswipeSlideItems = [];

      $slides.each(function() {
        var $slide = $(this);
        var $slideImage = $slide.find('img');

        photoswipeSlideItems.push({
          el: $slide[0],
          msrc: $slideImage.attr('src'),
          src: $slideImage.attr('src'),
          h: parseInt($slideImage[0].naturalHeight),
          w: parseInt($slideImage[0].naturalWidth)
        });
      });

      return photoswipeSlideItems;
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(event) {
      event.preventDefault();

      var $el = $(event.target);
      var $clickedListItem = $el.closest('.cw-lot-carousel-slide');
      var $clickedGallery = $clickedListItem.parent();
      var $clickedListItemSiblings = $clickedGallery.children();
      var index = $clickedListItemSiblings.index($clickedListItem);

      $clickedListItem.addClass('slick-slide-hidden');

      if (index >= 0) {
        // open PhotoSwipe if valid index found
        openPhotoSwipe(index, $clickedGallery);
      }

      return false;
    };

    var openPhotoSwipe = function(index, $galleryElement) {
      var pswpElement = document.querySelectorAll('.pswp')[0];
      var gallery;
      var options;
      var items;
      var selectedIndex = parseInt(index, 10);

      items = parseThumbnailElements($galleryElement);

      options = {
        index: selectedIndex,
        closeOnScroll: false,
        history: false,
        maxSpreadZoom: 3,
        shareEl: false,
        galleryUID: $galleryElement.attr('data-pswp-uid'),

        getThumbBoundsFn: function(selectedIndex) {
          var thumbnail = items[selectedIndex].el.getElementsByTagName('img')[0]; // find thumbnail
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();

          return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        }
      };

      // pass data to PhotoSwipe and initialize it
      gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();

      var $slickCarousel = $('.cw-lot-carousel');

      gallery.listen('initialZoomIn', function() {
        $slickCarousel.slick('slickPause');
      });

      gallery.listen('initialZoomOut', function() {
        $slickCarousel.slick('slickPlay');
      });

      gallery.listen('initialZoomOutEnd', function() {
        $slickCarousel
          .find('.slick-slide-hidden')
          .removeClass('slick-slide-hidden');
      });

      gallery.listen('afterChange', function() {
        var activeIndex = gallery.currItem.el.dataset.slickIndex;

        $slickCarousel.slick('slickGoTo', activeIndex, false);

        $slickCarousel
          .find('.slick-slide-hidden')
          .removeClass('slick-slide-hidden');

        $slickCarousel
          .find('[data-slick-index=' + activeIndex + ']')
          .addClass('slick-slide-hidden');
      });
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(gallerySelector);

    galleryElements.forEach(function(el, i) {
      el.setAttribute('data-pswp-uid', i - 1);
      el.onclick = onThumbnailsClick;
    });
  };

  var cwLotGallery = function() {
    // dependent on Photoswipe!
    // http://photoswipe.com/
    if (typeof PhotoSwipe !== "undefined") {
      var speed = 250;
      var thumb_size = 50;
      var thumb_margin = 10;
      var nav_size = 34;
      var ambilight = false; // for later... :)
      var pswp;
      var caption = $('.lot_title').text();
      var lot_id = $('#lot_id').val();

      var initLightbox = function($gallery, index) {
        index = index || 0;
        var options = {
          index: index, // start at first slide
          bgOpacity: 0.75,
          closeOnScroll: false,
          history: false,
          maxSpreadZoom: 3,
          shareButtons: [
            { id:'download', label:'Download image', url:'{{raw_image_url}}', download:true }
          ],
          shareEl: false,
          getThumbBoundsFn: function() {
            var thumbnail = $gallery.big_image_link.find('img').get(0);
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        };

        pswp = new PhotoSwipe($('.pswp').get(0), PhotoSwipeUI_Default, $gallery.items, options);
        pswp.listen('afterChange', function() {
          if ($gallery) {
            setIndex($gallery, this.getCurrentIndex());
          }
        });
        pswp.listen('initialZoomIn', function() {
          $('html').addClass('pswp-open');
        });
        pswp.listen('close', function() {
          $('html').removeClass('pswp-open');
        });
        pswp.listen('destroy', function() {
          $gallery.main.focus();
          initLightbox($gallery, this.getCurrentIndex());
        });

        $gallery.big_image_link.on('click.lot_gallery', function(event){
          event.preventDefault();
          pswp.init();
          if (typeof(AB) !== "undefined" && AB !== null && AB.conversion) {
            AB.conversion('lot_gallery_lightbox');
          }
        });
      };

      $('.cw-lot-images').each(function(){
        var $gallery = {};
        $gallery.main = $(this);
        $gallery.thumbs = $gallery.main.find('.cw-lot-images-thumbs').eq(0);
        $gallery.thumb_links = $gallery.thumbs.find('.cw-lot-images-thumb a');
        $gallery.big_image = $gallery.main.find('.cw-image-big').eq(0);
        $gallery.big_image_link = $gallery.big_image.find('a').eq(0);
        $gallery.big_image_img = $gallery.big_image_link.find('img').eq(0);
        $gallery.show_all_thumbs = $gallery.main.hasClass('show_all_thumbs');
        $gallery.truncated = $gallery.show_all_thumbs && $gallery.main.hasClass('truncated');

        if ($gallery.truncated) {
          var $visible_thumbs = $gallery.thumb_links.filter(':visible');
          var n = $gallery.thumb_links.length - $visible_thumbs.length;
          $gallery.show_all = $('<div/>').addClass('cw-lot-images-show_all').text('+ ' + (n + 1));
          $gallery.show_all.on('click', function(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            showAll($gallery);
          });
          $visible_thumbs.last().prepend($gallery.show_all);
        }

        if (ambilight) {
          $gallery.big_image_blur = $gallery.big_image.children('.cw-image-big-blur').eq(0);
          $gallery.big_image_blur.css({
            'background-image': 'url(' + $gallery.big_image_img.attr('src') + ')'
          });
        }

        if ($gallery.thumbs.length > 0) {
          $gallery.thumb_links
            .each(function(i){
              $(this).on('click.lot_images', function(event){
                event.preventDefault();
                initLightbox($gallery, i);
                setIndex($gallery, i, $(this));
                if ($gallery.show_all_thumbs && !event.isTrigger) {
                  openLightbox($gallery.big_image_link);
                }
              });
            })
            .eq(0).addClass('active');
          var $previous_thumbs = $('<a/>')
            .addClass('cw-lot-images-thumbsnav-previous')
            .html('&#xe0c7;')
            .on('click.lot_images_nav', function(event){
              event.preventDefault();
              $gallery.thumbs.animate({scrollLeft: '-='+($gallery.thumbs.innerWidth()-(nav_size*2-thumb_margin))}, speed*2);
            })
            .hide();
          var $next_thumbs = $('<a/>')
            .addClass('cw-lot-images-thumbsnav-next')
            .html('&#xe0ca;')
            .on('click.lot_images_nav', function(event){
              event.preventDefault();
              $gallery.thumbs.animate({scrollLeft: '+='+($gallery.thumbs.innerWidth()-(nav_size*2-thumb_margin))}, speed*2);
            })
            .hide();
          var $previous_image = $('<a/>')
            .addClass('cw-lot-images-nav cw-lot-images-nav-previous')
            .html('&#xe0bb;')
            .attr('title', TRANSLATIONS.gallery_previous_left_key)
            .on('click.lot_images_nav', function(event){
              event.preventDefault();
              navigatePrevious($gallery);
            });
          var $next_image = $('<a/>')
            .addClass('cw-lot-images-nav cw-lot-images-nav-next')
            .html('&#xe0be;')
            .attr('title', TRANSLATIONS.gallery_next_right_key)
            .on('click.lot_images_nav', function(event){
              event.preventDefault();
              navigateNext($gallery);
            });
          var timer;
          $gallery.main
            .attr('tabindex', 1)
            .on('focus', function(){ activateKeys($gallery); })
            .on('blur', function(){ deactivateKeys($gallery); })
            .append(
              $('<div/>').addClass('cw-lot-images-thumbsnav').append($previous_thumbs).append($next_thumbs)
            );
          $gallery.big_image
            .append($previous_image)
            .append($next_image);
          $gallery.main.find('a')
            .attr('tabindex', 1)
            .on('focus', function(){ activateKeys($gallery); })
            .on('blur', function(){ deactivateKeys($gallery); });
          if (!$gallery.show_all_thumbs) {
            $gallery.thumbs
              .on('DOMMouseScroll mousewheel', function(event){
                // prevent scroll event bubbling up to the whole document
                var s = $(this).scrollLeft();
                if (s < 1 && event.originalEvent.deltaX < 0) {
                  event.preventDefault();
                }
                if (s >= $gallery.thumbs.get(0).scrollWidth - $gallery.thumbs.innerWidth() && event.originalEvent.deltaX > 0) {
                  event.preventDefault();
                }
              })
              .on('scroll.lot_images_nav', function(){
                var s = $(this).scrollLeft();
                if (s < 1) {
                  $previous_thumbs.fadeOut(speed);
                } else {
                  $previous_thumbs.fadeIn(speed);
                }
                if (s >= $gallery.thumbs.get(0).scrollWidth - $gallery.thumbs.innerWidth()) {
                  $next_thumbs.fadeOut(speed);
                } else {
                  $next_thumbs.fadeIn(speed);
                }
                $(window).trigger('scroll'); // trigger lazy images
              });
          }
          if ($gallery.thumbs.get(0).scrollWidth > $gallery.thumbs.innerWidth()) {
            $next_thumbs.show();
          }
        }

        // lightbox
        $gallery.items = [];
        if ($gallery.thumbs.length > 0) {
          $gallery.thumbs.find('a').each(function(){
            var item_width = $(this).attr('data-original-width');
            var item_height = $(this).attr('data-original-height');
            if (item_width == 'auto' || item_height == 'auto') {
              var $item_image = $(this).find('img').eq(0);
              item_width = $item_image.width() * 14;
              item_height = $item_image.height() * 14;
            }
            $gallery.items[$gallery.items.length] = {
              src: $(this).attr('href'),
              msrc: $(this).attr('href'),
              w: item_width,
              h: item_height,
              title: caption
            };
          });
          initLightbox($gallery);
        } else {
          var item_width = $gallery.big_image_link.attr('data-original-width');
          var item_height = $gallery.big_image_link.attr('data-original-height');
          if (item_width == 'auto' || item_height == 'auto') {
            item_width = $gallery.big_image_img.width() * 2;
            item_height = $gallery.big_image_img.height() * 2;
          }
          $gallery.items[0] = {
            src: $gallery.big_image_link.attr('href'),
            msrc: $gallery.big_image_link.attr('href'),
            w: item_width,
            h: item_height,
            title: caption
          };
          initLightbox($gallery);
        }
      });

      var setIndex = function($gallery, i, $el) {
        $el = $el || $gallery.thumb_links.eq(i);
        $gallery.main.find('.active').removeClass('active');
        $el.addClass('active');
        var url = $el.attr('href');
        $gallery.big_image_link.attr('href', url);
        $gallery.big_image_img.attr('src', url);

        if (ambilight) {
          $gallery.big_image_img.on('load', function(){
            $gallery.big_image_blur.css({
              'background-image': 'url('+url+')'
            });
          });
        }

        // scroll thumbs in to view
        if ($gallery.thumbs.length > 0) {
          var y_pos = $gallery.thumbs.scrollLeft() - $gallery.thumbs.offset().left + $el.offset().left;
          if ($el.offset().left - $gallery.thumbs.offset().left > $gallery.thumbs.innerWidth() - (thumb_size+nav_size)) {
            // too far to the right
            $gallery.thumbs.animate({scrollLeft: y_pos - $gallery.thumbs.innerWidth() + nav_size + thumb_size}, speed/2);
          }
          else if ($el.offset().left - $gallery.thumbs.offset().left < nav_size) {
            // too far to the left
            $gallery.thumbs.animate({scrollLeft: y_pos - nav_size}, speed/2);
          }
        }

        if ($gallery.truncated) {
          showAll($gallery);
        }
      };

      var showAll = function($gallery) {
        $gallery.truncated = false;
        $gallery.show_all.remove();
        setTimeout(function() { // Show thumbs async, to prevent delay
          $gallery.main.removeClass('truncated');
          $(document).trigger('scroll');
        }, 0);
      };

      var activateKeys = function($gallery) {
        $gallery.main.on('keydown.lot_images', function(event) {
          if (event.keyCode == 37 || event.keyCode == 38) { // left or up
            event.preventDefault();
            navigatePrevious($gallery);
          }
          if (event.keyCode == 39 || event.keyCode == 40) { // right or down
            event.preventDefault();
            navigateNext($gallery);
          }
          if (event.keyCode == 13) { // enter
            event.preventDefault();
            openLightbox($gallery.big_image_link);
          }
        });
      };

      var deactivateKeys = function($gallery) {
        $gallery.main.off('keydown.lot_images');
      };

      var navigatePrevious = function($gallery) {
        var $current_thumb = $gallery.thumb_links.filter('.active').parent();
        if ($current_thumb.hasClass('cw-lot-images-thumb-first')) {
          $gallery.thumbs.find('.cw-lot-images-thumb-last a').eq(0).trigger('click');
        } else {
          $current_thumb.prev().find('a').eq(0).trigger('click');
        }
      };

      var navigateNext = function($gallery) {
        var $current_thumb = $gallery.thumb_links.filter('.active').parent();
        if ($current_thumb.hasClass('cw-lot-images-thumb-last')) {
          $gallery.thumbs.find('.cw-lot-images-thumb-first a').eq(0).trigger('click');
        } else {
          $current_thumb.next().find('a').eq(0).trigger('click');
        }
      };

      var openLightbox = function($lightbox_link) {
        $lightbox_link.trigger('click');
      };
    }
  };


  var cwSlider = function() {
    var speed = 500;
    var fps = 30;
    $('.cw-slider').each(function(){
      var $container = $(this);
      var $slider = $container.find('.cw-tiles');
      var $slide_previous = $('<a/>')
        .addClass('cw-slider__nav__previous inactive')
        .on('click.slider', function(event){
          event.preventDefault();
          $slider.animate({scrollLeft: '-='+($slider.innerWidth() - 40)}, speed);
        })
        .append(
          $('<span/>').html('&#xe0c7;')
        );
      var $slide_next = $('<a/>')
        .addClass('cw-slider__nav__next inactive')
        .on('click.slider', function(event){
          event.preventDefault();
          $slider.animate({scrollLeft: '+='+($slider.innerWidth() - 40)}, speed);
        })
        .append(
          $('<span/>').html('&#xe0ca;')
        );
      $container.append(
        $('<div/>').addClass('cw-slider__nav').append($slide_previous).append($slide_next)
      );
      var doOnScroll = function(){
        var s = $slider.scrollLeft();
        if (s < 1) {
          $slide_previous.addClass('inactive');
        } else {
          $slide_previous.removeClass('inactive');
        }
        if (s >= $slider.get(0).scrollWidth - $slider.innerWidth()) {
          $slide_next.addClass('inactive');
        } else {
          $slide_next.removeClass('inactive');
        }
        $(window).trigger('scroll'); // trigger lazy images
      }
      $slider.on('scroll.slider', throttle(doOnScroll, 1000/fps));
      if ($slider.get(0).scrollWidth > $slider.innerWidth()) {
        $slide_next.removeClass('inactive');
      }
    });
  };



  var cwPreventFocusZoom = function() {
    var viewportmeta = document.querySelector('meta[name="viewport"]');
    var viewport_original = viewportmeta.content;
    var viewport_no_zoom = "width=device-width,initial-scale=1,maximum-scale=1.0";
    var disableZoom = function() {
      var $inputs = $('input, textarea');
      $inputs.each(function(){
        $(this)
          .on('touchstart.cwPreventFocusZoom focus.cwPreventFocusZoom', function(){
            viewportmeta.content = viewport_no_zoom;
          })
          .on('blur.cwPreventFocusZoom', function(){
            viewportmeta.content = viewport_original;
          });
      });
    };
    if (viewportmeta && Modernizr.touch) {
      disableZoom();
    }
  };



  var initLazyload = function() {
    $(".cw-lazy_images_collection").each(function(){
      var $_this = $(this);
      var timer = null;
      $_this.find("img.lazy").lazyload({
        threshold: 200,
        load: function() {
          if ($_this.data('isotope')) {
            if (!timer) {
              timer = setTimeout(function(){ // throttle
                $_this.isotope();
                timer = null;
              }, 1000);
            }
          }
        }
      });
    });
  };



  var cwBacklinks = function() {
    $('a.cw-back_link').on('click.back_link', function(evt){
      if (window.history.length > 1) {
        evt.preventDefault();
        window.history.back();
      }
    });
  };



  var cwAuctioneers = function() {
    var $container = $('#cw_auctioneers_overview');
    var $iso_list = $container.find('.cw-tiles.cw-msnry');
    var $auctioneers = $iso_list.find('.cw-list-item[data-cw-inline-modal="true"]');
    var $filter = $container.find('select');
    $auctioneers.each(function() {
      $(this)
        .addClass('active')
        .hover(function(){
          $(this).addClass('hover');
        }, function(){
          $(this).removeClass('hover');
        })
        .on('touchstart', function(){
          $(this).addClass('hover');
        })
        .on('touchend', function(){
          $(this).removeClass('hover');
        })
        .on('click', function(){
          var auctioneer_id = $(this).attr('data-auctioneer_id');
          HashBang.set('auctioneer', auctioneer_id);
        })
        .find('a')
          .on('click', function(evt){
            evt.stopPropagation();
          });
    });
    $filter.on('change', function(){
      $("img.lazy").updateLazyLoad();
    });
    var current_auctioneer = HashBang.get('auctioneer');
    if (current_auctioneer > 0) {
      $auctioneers.filter('[data-auctioneer_id='+current_auctioneer+']').trigger('click');
      $(window).trigger('scroll'); // trigger lazy images
    }
  };



  var cwColorize = function() {
    // item selector: .cw-colorize
    // set item background-color to the average color of the top part of the 1st image found in item
    if (supportCanvas()) {

      var debug = false;
      var total_time = 0;
      var border_fraction = 0.02; // take top 5% of image

      var getColor = function($item, image){
        if (debug) {
          console.log('--- Colorize image ---');
          if (window.performance.now) {
            var t1 = window.performance.now();
          } else {
            var t1 = new Date().getTime();
          }
        }
        var canvas = document.createElement('canvas');
        var canvasContext = canvas.getContext("2d");
        // resize image (4*20) to make processing faster
        var w = 4;
        var h = 50;
        canvas.width = w;
        canvas.height = h;
        canvasContext.drawImage(image, 0, 0, w, h);
        // try, because image server may nog support CORS,
        // or browser might not handle it correctly (IE10)
        try {
          var image_data = canvasContext.getImageData(0, 0, w, h);
          var image_rgba_data = image_data.data; // array [R,G,B,a,R,G,B,a,R,G,B,a,...]
          var pixels = Math.ceil((image_rgba_data.length * border_fraction) / 4);// how many pixels in the crop
          var rgb = {r:0,g:0,b:0};
          for (var i=0; i<pixels*4; i+=4) {
            rgb.r += image_rgba_data[i];
            rgb.g += image_rgba_data[i+1];
            rgb.b += image_rgba_data[i+2];
          }
          // calculate averages for R/G/B
          rgb.r = Math.round(rgb.r / pixels);
          rgb.g = Math.round(rgb.g / pixels);
          rgb.b = Math.round(rgb.b / pixels);
          $item.css('background-color', 'rgb('+rgb.r+','+rgb.g+','+rgb.b+')');
          if (debug) {
            if (window.performance.now) {
              var t2 = window.performance.now();
            } else {
              var t2 = new Date().getTime();
            }
            var time_taken = t2 - t1;
            total_time += time_taken
            console.log('rgb('+rgb.r+','+rgb.g+','+rgb.b+') | ' + (Math.round(time_taken*1000)/1000) + 'ms / ' + (Math.round(total_time)/1000) + 's | "' + image.alt + '"');
          }
        }
        catch(err) {
          if (debug) {
            console.log('ERROR:');
            console.log($item);
            console.log(image);
            console.log(err);
          }
        }
      };

      if (!$('html').hasClass('lt-ie10')) {
        $('.cw-colorize').each(function(){
          // crossOrigin loading through attribute not reliable on iOS9,
          // so set it through javascript
          var $item = $(this);
          var image = $item.find('img').get(0);
          var src = $(image).attr('src');
          if (image) {
            if (src != '/images/img_place_holder.gif') {
              // not lazy loaded: re-request image with crossOrigin
              image = new Image();
              image.crossOrigin = 'anonymous';
              image.src = src + '?cors=true';
            } else {
              image.crossOrigin = 'anonymous';
            }
            $(image).on('load.cwColorize', function() {
              getColor($item, image);
            });
          }
        });
      }

    }
  };



  var calculateShippingCosts = function() {
    var $shipping_rate = $('.js-shipping_rate_container').first();
    var url = $shipping_rate.data('packlink_url');
    var allowed_carrier_names = $shipping_rate.data('carriers');
    var service_filter = $shipping_rate.data('service_filter'); // all / pickup / dropoff
    var vat_shipping_rate = $shipping_rate.data('vat_shipping_rate');
    var prices = [];
    if (url) {
      $.ajax(url, {
        complete: function(jqXHR, textStatus) {
          if (textStatus == 'success') {
            var carriers = JSON.parse(jqXHR.responseText);
            var cheapest_carrier = false;
            $(carriers).each(function(){
              // check if it's in allowed carriers
              if ($.inArray(this.carrier_name, allowed_carrier_names) !== -1) {
                // check dropoff / pickup
                if ((service_filter == 'pickup' && !this.dropoff) || (service_filter == 'dropoff' && this.dropoff) || (service_filter != 'pickup' && service_filter != 'dropoff')) {
                  // check if it's cheapest
                  if (!cheapest_carrier || parseFloat(this.base_price) < parseFloat(cheapest_carrier.base_price)) {
                    cheapest_carrier = this;
                  }
                }
              }
            });
            if (cheapest_carrier) {
              var base_price = parseFloat(cheapest_carrier.base_price);
              var price = (1 + vat_shipping_rate/100) * base_price;
              var formatted_price = Catawiki.currencyHelper.localize(price, {currency: Catawiki.currencyHelper.biddingCurrency, floatValue: true, skipCurrenciesFilter: true});
              $('.js-shipping_rate_container__value').each(function(){
                $(this).html(formatted_price);
              });
            }
          }
        }
      });
    }
  };



  var areYouSureLinks = function() {
    $('a.cw-are_you_sure').on('mousedown', function(event){
      event.preventDefault();
      if (confirm(TRANSLATIONS.are_you_sure)) {
        jQuery(this).trigger('click');
      } else {
        return false;
      }
    });
  };

  var dynamiclyLoadedAuctions = function(){
    var containerID = '#dynamiclyLoadedAuctions';
    var goAhead = ($(containerID).length > 0 && $(containerID).data('dynamic-auction-path'));
    if(goAhead){
      $.ajax({
        type: 'GET',
        url: $(containerID).data('dynamic-auction-path'),
        data: {'locale': $('body').data('lang')},
        cache: false,
        success: function(data) {
          if(data.length > 10){
            $(containerID).html(data).blockLinks();
            initLazyload();
            new Mason(containerID).init();
            $(window).trigger('scroll');
          }else{
            window.location = window.location.href.replace('?type=recommended', '');
          }
        }
      });
    }
  }

  window.cwInitResponsiveness = function(){
    // extra info (from sidebar) in dropdown
    var $side_menu = $('#cw-mobile-side_menu');
    if ($side_menu.length > 0 && $(window).width() < 747) {
      var $side_menu_switch = $side_menu.find('.more_auctions_dropdown__trigger').eq(0).removeClass('hide');
      var $list = $side_menu.find('ul.cw-list-thumb_list, .more_auctions_dropdown__content').eq(0);
      $side_menu.addClass('more_auctions_dropdown').prependTo($('.cw-auction').eq(0));
      var openExtraMenu = function() {
        $side_menu.addClass('open');
        $('body').on('mousedown.ExtraMenu touchstart.ExtraMenu', function(evt){
          closeExtraMenu();
        });
      };
      var closeExtraMenu = function() {
        $side_menu.removeClass('open');
        $('body').off('mousedown.ExtraMenu touchstart.ExtraMenu');
      };
      $side_menu_switch.on('click', function(evt){
        if ($side_menu.hasClass('open')) {
          closeExtraMenu();
        } else {
          openExtraMenu();
        }
      });
      $side_menu.on('mousedown touchstart', function(evt){
        evt.stopPropagation();
      });
    }
  };

  // Recent search storage
  $("#cw-searchbox form").on('submit', function(event) {
    if (cw_store.enabled) {
      var max_search_history_length = 5;
      var search_history_key = 'previous_searches';
      var search_query = $(event.target).find('input[type=search]').val();
      // Do nothing if search query is empty
      if (search_query && search_query !== '') {
        var search_history = cw_store.get_json(search_history_key) || [];
        search_history.unshift(search_query);
        // Only store latest 3 unique searches
        cw_store.set_json(search_history_key, $.unique(search_history).reverse().slice(0, max_search_history_length));
      }
    }
  });

  $("#cw-searchbox, .cw-searchbox").on('awesomplete-select', function(event) {
    var origin = $(event.originalEvent.origin);
    if (origin.hasClass('search-history-delete')) {
      var search_history_key = 'previous_searches';
      var search_history = cw_store.get_json(search_history_key) || [];
      var index = $.inArray(origin.data('text'), search_history);
      if (index !== -1) {
        search_history.splice(index, 1);
        cw_store.set_json(search_history_key, search_history);
      }
      origin.parent().remove();
      return false;
    }
    return true;
  });

  // Search autocomplete
  $(document).ready(function($) {
    var $searchInputs = $('.js-search-autocomplete');
    if (!$searchInputs.length) {
      return;
    }

    var filterListByType = function (list, type) {
      return list.filter(function(item) {
        return item.entity.type === type;
      });
    };

    var orderSuggestions = function (list) {
      var categoryList = filterListByType(list, 'category');
      var auctionList = filterListByType(list, 'auction');

      var queryLimit = settings.resultsLimit - categoryList.length - auctionList.length;
      var queryList = filterListByType(list, 'query_term').slice(0, queryLimit);

      return [].concat(
        queryList,
        categoryList,
        auctionList
      );
    };

    var settings = {
      resultsLimit: 10,
      keystrokeTimer: 0,
      url: '/buyer/api/v1/search/suggest',
      locale: $('html').attr('lang'),
    };

    // https://jira.catawiki.net/browse/SND-157
    if (typeof AB !== 'undefined') {
      var placeholderTranslationKey = $('.js-ab-search-placeholder')
        .data('abSearchPlaceholder' + AB.test('searchbar_text_placeholder'));
      $searchInputs.attr('placeholder', placeholderTranslationKey);
    }

    var onCategoryClick = function(url) {
      if (typeof AB === 'undefined' || !window.google_tag_manager) {
        return false;
      }

      AB.conversion(
        'search_autocomplete_clicked_categorysuggestion',
        null,
        null,
        function() {
          window.dataLayer.push({
            event: 'ga-event',
            eventCategory: 'search',
            eventAction: 'autocompleteClicked',
            eventLabel: 'categorysuggestion',
            eventCallback: function() {
              window.location = url;
            },
          });
        }
      );
    };

    var onAuctionClick = function(url) {
      if (typeof AB === 'undefined' || !window.google_tag_manager) {
        return false;
      }

      AB.conversion(
        'search_autocomplete_clicked_auctionsuggestion',
        null,
        null,
        function() {
          window.dataLayer.push({
            event: 'ga-event',
            eventCategory: 'search',
            eventAction: 'autocompleteClicked',
            eventLabel: 'auctionsuggestion',
            eventCallback: function() {
              window.location = url;
            },
          });
        }
      );
    };

    var onSearchTermClick = function(input) {
      if (typeof AB === 'undefined' || !window.google_tag_manager) {
        return false;
      }

      AB.conversion(
        'search_autocomplete_clicked_searchtermsuggestion',
        null,
        null,
        function() {
          window.dataLayer.push({
            event: 'ga-event',
            eventCategory: 'search',
            eventAction: 'autocompleteClicked',
            eventLabel: 'searchtermsuggestion',
            eventCallback: function() {
              $(input)
                .closest('form')
                .trigger('submit');
            },
          });
        }
      );
    };

    var renderAutocompleteItem = function(searchQuery, type, label) {
      var html = '<div class="c-header__search__list-item">' + (
        label
          ? searchQuery +
            '<em class="c-header__search__type-value"> - ' +
            label +
            '</em>'
          : searchQuery
        ) + '</div>';
      var className = 'c-header__search__type--' + type;

      return $('<li>', {
        html: html,
        class: className,
      })[0];
    };

    var bindAutocomplete = function($input) {
      var autocomplete = new window.Awesomplete($input.get(0), {
        minChars: 3,
        maxItems: settings.resultsLimit,
        list: [],
        data: function(item) {
          return {
            label: item.text,
            value: {
              highlighted: item.highlighted,
              type: item.entity.type,
              typeValue: item.entity.value,
              url: item.entity.url,
              index: item.index,
            },
          };
        },
        sort: false,
        item: function(item) {
          var searchQuery = item.value.highlighted || '<mark>' + item.label + '</mark>';
          var type = item.value.type;
          var typeValue = item.value.typeValue;
          var index = item.value.index;
          var label = typeValue;

          return renderAutocompleteItem(searchQuery, type, label);
        },
        replace: function(item) {
          var onSearchItemClick = item.value.type === 'category'
            ? onCategoryClick : onAuctionClick;
          item.value.url
            ? onSearchItemClick(item.value.url)
            : onSearchTermClick(autocomplete.input);
        },
        filter: function() {
          // don't let Awesomplete filter, API already returns filtered data!
          return true;
        },
      });

      var keystrokeTimer;
      var resetTimer;
      var timeBeforeNewRequest = 0;

      $input
        .on('awesomplete-highlight', function() {
          autocomplete.input.value =
            autocomplete.suggestions[autocomplete.index].label;
        })
        .on('awesomplete-open', function() {
          AB.conversion('search_autocomplete_opened');
        })
        .on('input', function() {
          var query = $(this).val();
          if (query.length < autocomplete.minChars) {
            autocomplete.list = [];
            return;
          }

          settings.filters = ['query_terms', 'auctions', 'categories'];

          $(autocomplete.container).addClass('ab-search-suggestions-auctions');

          clearTimeout(keystrokeTimer);
          keystrokeTimer = setTimeout(function() {
            // do next request after timer, unless timer has already passed
            timeBeforeNewRequest = settings.keystrokeTimer;
            clearTimeout(resetTimer);
            resetTimer = setTimeout(function() {
              timeBeforeNewRequest = 0;
            }, timeBeforeNewRequest);

            $.ajax({
              type: 'GET',
              url: settings.url,
              data: {
                q: query,
                locale: settings.locale,
                size: settings.resultsLimit,
                filters: settings.filters.join(','),
              },
              success: function(data) {
                var list = data.query_terms
                  .filter(function(item) {
                    return item;
                  });

                var orderedList = orderSuggestions(list);

                autocomplete.list = orderedList.map(function(item, index) {
                  return $.extend({}, item, { index: index });
                });

                var $autocompleteList = $(autocomplete.ul);
                var $autocompleteCategories = $autocompleteList.find('.c-header__search__type--category');
                var $autocompleteAuctions = $autocompleteList.find('.c-header__search__type--auction');

                if ($autocompleteCategories.length) {
                  var $firstCategory = $autocompleteCategories.first();

                  $firstCategory
                    .prepend(
                      '<div class="c-header__search__heading">'
                      + $('.js-search-autocomplete[data-categories-heading]').data('categories-heading')
                      + '</div>'
                    );
                }

                if ($autocompleteAuctions.length) {
                  $autocompleteAuctions
                    .first()
                    .prepend(
                      '<div class="c-header__search__heading">'
                      + $('.js-search-autocomplete[data-auctions-heading]').data('auctions-heading')
                      + '</div>'
                    );
                }
              },
            });
          }, timeBeforeNewRequest);
        });
    };

    $searchInputs.each(function() {
      var $input = $(this);
      $input.on('focus.searchcomplete', function() {
        $input.off('focus.searchcomplete');
        if (['zh_CN', 'zh_TW'].indexOf(settings.locale) === -1) {
          bindAutocomplete($input);
          setTimeout(function() {
            $input.trigger('focus');
          }, 0);
        }
      });
    });
  });

  window.cwAlerts = {
    createAlert: function(type, content) {
      var $alert = $('<div/>', {'class': ('hide c-alert ' + type)});
      if(typeof(content) === "object"){
        var $title = $('<h3/>', {'html': content.title, 'class': 'c-alert__heading'});
        $alert.html($title);
        $alert.append(content.message);
      }else{
        $alert.html(content);
      }
      return $alert;
    },
    removeAlert: function($alert, duration) {
      setTimeout(function(){
        $alert.fadeOut(500, function(){
          $(this).remove();
        });
      }, duration);
    },
    setAlert: function(type, content, container, duration, callback) {
      if(!type || !content){
        return;
      }
      var $alert = this.createAlert(type, content);
      var $container = !!container ? $(container) : $('#flash');
      $alert.prependTo($container).fadeIn(500);
      if(!!duration){
        this.removeAlert($alert, duration);
      }
      if(!!callback){
        callback();
      }
    }
  }


  // AB tests on search
  var cwSearchAbTests = function() {

    if(I18n && I18n.translate && typeof(AB) != "undefined" && AB != null){
      // different search placeholder for en and nl
      var $search_input = $('.cw-header #search_lots_query');
      if($search_input.length > 0 && ['en', 'nl'].indexOf($('body').data('lang')) != -1 &&
          I18n.translate('what_are_you_looking_for').indexOf('translation missing:') == -1) {
        $search_input.attr('placeholder', I18n.translate('what_are_you_looking_for'));
      }
    }
  };

  // Helpers
  var cwPluralize = function($el, n) {
    if (n == 1) {
      $el.text($el.data('singular'));
    } else {
      $el.text($el.data('plural'));
    }
  };
  function cw_iOS() {
    return (
      (/iphone|ipod|ipad/gi).test(navigator.appVersion)
    );
  }
  function cw_iPad() {
    return (
      (/ipad/gi).test(navigator.appVersion)
    );
  }
  function cw_android() {
    return (
      (/android/gi).test(navigator.appVersion)
    );
  }
  function supportCanvas() {
    return !!window.CanvasRenderingContext2D;
  }

  var cwGetSelectedOptionText = function($element) {
    if ($element.length > 0) {
      try { return $($element.get(0).options[$element.get(0).selectedIndex]).text(); }
      catch(err) { return $($element.get(0).options[$element.eq(0).selectedIndex]).text(); }
    }
  };

  /**
   * Throttle function borrowed from:
   * Underscore.js 1.5.2
   * http://underscorejs.org
   * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   * Underscore may be freely distributed under the MIT license.
   */
  function throttle(func, wait) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    var later = function() {
      previous = new Date();
      timeout = null;
      result = func.apply(context, args);
    };
    return function() {
      var now = new Date();
      if (!previous) {
        previous = now;
      }
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
      } else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  }

  //AB click conversions
  var abClickConversions = function() {
    $('body').on('click.ab-click-conversion', '.cw-ab_click', function(){
      if($(this).hasClass('active')) return false;
      var goal = $(this).data('ab-conversion');
      if(goal) {
        AB.conversion(goal);
      }
      var ab_id =  $(this).data('ab-id');
      var ab_label = $(this).text();
      if(ab_id && ab_label){
        //ga('send', 'event', 'AB testing', ab_id, ab_label.trim(), {nonInteraction:false});
        dataLayer.push({
          'event': 'ab_click',
          'eventCategory': 'AB testing',
          'eventAction': ab_id,
          'eventLabel': ab_label.trim(),
        });
      }
    });
  };

  window.ab_translate = function(translate_key, ab_key) {
    // Returns either translated `key` or `key_alt`, depending experiment `ab_key` returns `A` or `B`.
    // Only done when `key` translation is different from `key_alt` translation
    var translation_a = I18n.translate(translate_key, { defaultValue: '' });
    var translation_b = I18n.translate(translate_key + '_alt', { defaultValue: translation_a });
    if (translation_a != translation_b && typeof AB !== "undefined" && AB.test(ab_key) == 'B') {
      return translation_b;
    } else {
      return translation_a;
    }
  }

  function user_is_logged_in(){
    var user_name = jQuery.cookie('user_name');
    return (user_name && typeof user_name == "string");
  }

  var initToggleThemedAuctions = function() {
    if(!user_is_logged_in()){
      cw_show_lists_auctions_themed();
    }
  };

  var initToggleListsAuctionActual = function() {
    if(!user_is_logged_in()){
      cw_show_lists_auctions_actual();
    }
  };

  $(window).on('load', function() {
    if (!user_is_logged_in() && !$('body').hasClass("cw_mobile")) {
      var path = window.location.pathname;

      if (path.indexOf('/r/') === 0) {
        var url = $('.register_link').attr('data-magnific-popup-link');
        setTimeout(function() { cw_open_register_modal($, url); }, 1000);
      }
    }
  });

  // start it all...
  $(document).ready(function() {
    $('html').removeClass('no-js').addClass('js');
    if (cw_iOS()) {
      $('html').addClass('browser-ios');
      if (cw_iPad()) {
        $('html').addClass('browser-ipad');
      }
    } else {
      $('html').addClass('browser-not_ios');
    }
    if (cw_android()) {
      $('html').addClass('browser-android');
    } else {
      $('html').addClass('browser-not_android');
    }
    // provide fallbacks: IE7 doesn't get isotope and imagesLoaded...
    if(!$().isotope) {
      $.fn.extend({
        isotope: function(){}
      });
    }
    if(!$().imagesLoaded) {
      $.fn.extend({
        imagesLoaded: function(cb){
          setTimeout(function(){
            cb();
          }, 1000);
        }
      });
    }
    if (!disable_marketing_cookies_for_user()){
      loadSocialMediaAsync();
    }
    cwToggleLinks();
    cwCollapsibles();
    window.cwInitResponsiveness();
    $('.cw-sticky').makeSticky();
    $('a.cw-new_window').newWindow();
    $('a.cw-popup_link').newWindow('width=750,height=525,status=1,location=1');
    pageFillHeight();
    smoothAnchors(75);
    initLazyload();
    initToggleListsAuctionActual();
    initToggleThemedAuctions();
    $('#cw_auctioneers_overview').imagesLoaded(function(){
      $('#cw_auctioneers_overview .cw-list-item .cw-content .info').sameHeight();
      $('#cw-main .cw-tiles-fixed_height .cw-list-item .cw-content h2').sameHeight();
      var tiles = new Mason('#all .cw-tiles.cw-msnry', '.cw-list-item');
      tiles.init();
      cwAuctioneers();
    });
    $('#all .cw-list-agenda li').sameHeight(); // zit in verborgen tab, dus meteen, anders doet ie t niet...
    $('#cw-main .cw-tiles, #cw-main .cw-horizontal_tiles, #cw-free_valuation_promo').blockLinks();
    cwTabs();
    setLoginClass();
    activatePopups();
    window.inlineHints.init();
    initGalleries();
    showLoginModal();
    changeSVGtoPNG();
    $('input, textarea').placeholder();
    if (isMobile() && ab_or_mobile_swipable_image_gallery()) {
      initLotGallerySwiper();
      initLotGalleryMobile('.cw-image-link');
    } else {
      cwLotGallery();
    }
    cwSlider();
    cwNiceSelects();
    //$('.cw-stick_to_top').stickToTop();
    cwBacklinks();
    $().UItoTop({ containerID: 'cw_to_top', scrollSpeed: 400, easingType: 'swing', visibleClassName: 'back-to-top-visible' });
    appSignup();
    toggleGrid();
    abClickConversions();
    calculateShippingCosts();
    cwSearchAbTests();

    if(I18n && I18n.translate && (I18n.translate('start_selling').indexOf('translation missing:') == -1) && (typeof AB !== "undefined" && AB.test('start_selling_text') == 'B')){
      var sell_text = I18n.translate('start_selling');
      $('.cw-header').find("a[href*='/auction_lot_wizard/start']").text(sell_text);
    }
    $('.cw-header').find("a[href*='/auction_lot_wizard/start']").on('click.header_sell_click', function(){
      AB.conversion('header_sell_click');
    });

    areYouSureLinks();
    dynamiclyLoadedAuctions();
  });

  $(document).ready(function() {
    var isDesktop = $(window).width() > 996;
    var userId = $.cookie('user_id');
    if (isDesktop && userId && AB.test('help_guides', { user_id: userId }) === 'B') {
      $('.js-ab-help-guides').removeClass('cw-hide');
    }
  });
})(jQuery);
